<template>
  <output-dialog
    :pages="pages"
    filename="フレイト I/V.pdf"
    orientation="portrait"
    ref="printDlg"
    title="フレイト I/V 出力"
  >
    <template slot-scope="{ page }">
      <div class="page" v-if="page.index === 0">
        <h1>Invoice</h1>
        <div class="no">
          <div>
            <div class="label">Invoice No：</div>
            <div class="value">{{ page.freightInvNo }}</div>
          </div>
          <div>
            <div class="label">Date：</div>
            <div class="value">{{ new Date() | moment('YYYY/MM/DD') }}</div>
          </div>
        </div>
        <div class="A">
          <div class="a" style="border-left: 3px solid #369; height: 100px">
            <div class="b">To:</div>
            <div>{{ page.englishName }}</div>
            <div></div>
            <div></div>
          </div>
          <div class="a" style="border-left: 3px solid #369; height: 100px">
            <div class="b">Sender:</div>
            <div>SHARP JUSDA LOGISTICS CORPORATION</div>
            <div>ADDRESS:1,TAKUMI-CHO,SAKAI-KU SAKAI-SHI</div>
            <div>OSAKA JAPAN</div>
          </div>
        </div>
        <div class="B">
          <div class="a">
            <table>
              <tr>
                <td v-if="page.isAir">AWB No</td>
                <td v-else>B/L No</td>
                <td v-if="page.isAir">{{ page.blNo }}</td>
                <td v-else>{{ page.blNo }}</td>
              </tr>
            </table>
          </div>
          <div class="b">
            <table>
              <tr>
                <td>Origin</td>
                <td>Destination</td>
                <td v-if="page.isAir">Chargeable Weight</td>
                <td v-else>CARRIER</td>
              </tr>
              <tr>
                <td>{{ page.loadingPortName }}</td>
                <td>{{ page.dischargePortName }}</td>
                <td v-if="page.isAir">{{ page.actualCw || 0 }} kg</td>
                <td v-else>{{ page.forwarderDisplayName }}</td>
              </tr>
            </table>
          </div>
        </div>

        <table v-if="page.isSea">
          <tr class="header">
            <td style="width: 5%"></td>
            <td colspan="2" style="width: 25%">Description</td>
            <td colspan="3" style="width: 40%">Amount</td>
            <td style="width: 15%"></td>
            <td style="width: 15%">JPY Amount</td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2"></td>
            <td>Rate</td>
            <td>Qty</td>
            <td>Amt</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">20F</td>
            <td style="text-align: right">
              {{
                (twentyFCurrency(page, 'SEA-001') +
                  twentyFPrice(page, 'SEA-001'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">{{ twentyFQty(page, 'SEA-001') }}</td>
            <td style="text-align: right">
              {{
                (twentyFCurrency(page, 'SEA-001') + twentyF(page, 'SEA-001'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">40F</td>
            <td style="text-align: right">
              {{
                (fourtyFCurrency(page, 'SEA-001') +
                  fourtyFPrice(page, 'SEA-001'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">{{ fourtyFQty(page, 'SEA-001') }}</td>
            <td style="text-align: right">
              {{
                (fourtyFCurrency(page, 'SEA-001') + fourtyF(page, 'SEA-001'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">40H</td>
            <td style="text-align: right">
              {{
                (fourtyHQCurrency(page, 'SEA-001') +
                  fourtyHQPrice(page, 'SEA-001'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">
              {{ fourtyHQQty(page, 'SEA-001') }}
            </td>
            <td style="text-align: right">
              {{
                (fourtyHQCurrency(page, 'SEA-001') + fourtyHQ(page, 'SEA-001'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right">&nbsp;</td>
          </tr>
          <tr>
            <td></td>
            <td>LSS</td>
            <td>20F</td>
            <td style="text-align: right">
              {{
                (twentyFCurrency(page, 'SEA-014') +
                  twentyFPrice(page, 'SEA-014'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">{{ twentyFQty(page, 'SEA-014') }}</td>
            <td
              style="text-align: right"
              v-if="twentyFCurrency(page, 'SEA-014').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (twentyFCurrency(page, 'SEA-014') + twentyF(page, 'SEA-014'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="twentyFCurrency(page, 'SEA-014').indexOf('JPY') != -1"
            >
              {{
                twentyFJpySubTotal(page, 'SEA-014')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td>40F</td>
            <td style="text-align: right">
              {{
                (fourtyFCurrency(page, 'SEA-014') +
                  fourtyFPrice(page, 'SEA-014'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">{{ fourtyFQty(page, 'SEA-014') }}</td>
            <td
              style="text-align: right"
              v-if="fourtyFCurrency(page, 'SEA-014').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (fourtyFCurrency(page, 'SEA-014') + fourtyF(page, 'SEA-014'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="fourtyFCurrency(page, 'SEA-014').indexOf('JPY') != -1"
            >
              {{
                fourtyFJpySubTotal(page, 'SEA-014')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>40H</td>
            <td style="text-align: right">
              {{
                (fourtyHQCurrency(page, 'SEA-014') +
                  fourtyHQPrice(page, 'SEA-014'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">
              {{ fourtyHQQty(page, 'SEA-014') }}
            </td>
            <td
              style="text-align: right"
              v-if="fourtyHQCurrency(page, 'SEA-014').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (fourtyHQCurrency(page, 'SEA-014') + fourtyHQ(page, 'SEA-014'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="fourtyHQCurrency(page, 'SEA-014').indexOf('JPY') != -1"
            >
              {{
                fourtyHQJpySubTotal(page, 'SEA-014')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right">&nbsp;</td>
          </tr>

          <tr>
            <td></td>
            <td>Export Charge</td>
            <td>20F</td>
            <td style="text-align: right">
              {{
                (twentyFCurrency(page, 'SEA-015') +
                  twentyFPrice(page, 'SEA-015'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">{{ twentyFQty(page, 'SEA-015') }}</td>
            <td
              style="text-align: right"
              v-if="twentyFCurrency(page, 'SEA-015').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (twentyFCurrency(page, 'SEA-015') + twentyF(page, 'SEA-015'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="twentyFCurrency(page, 'SEA-015').indexOf('JPY') != -1"
            >
              {{
                twentyFJpySubTotal(page, 'SEA-015')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>40F</td>
            <td style="text-align: right">
              {{
                (fourtyFCurrency(page, 'SEA-015') +
                  fourtyFPrice(page, 'SEA-015'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">{{ fourtyFQty(page, 'SEA-015') }}</td>
            <td
              style="text-align: right"
              v-if="fourtyFCurrency(page, 'SEA-015').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (fourtyFCurrency(page, 'SEA-015') + fourtyF(page, 'SEA-015'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="fourtyFCurrency(page, 'SEA-015').indexOf('JPY') != -1"
            >
              {{
                fourtyFJpySubTotal(page, 'SEA-015')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>40H</td>
            <td style="text-align: right">
              {{
                (fourtyHQCurrency(page, 'SEA-015') +
                  fourtyHQPrice(page, 'SEA-015'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">
              {{ fourtyHQQty(page, 'SEA-015') }}
            </td>
            <td
              style="text-align: right"
              v-if="fourtyHQCurrency(page, 'SEA-015').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (fourtyHQCurrency(page, 'SEA-015') + fourtyHQ(page, 'SEA-015'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="fourtyHQCurrency(page, 'SEA-015').indexOf('JPY') != -1"
            >
              {{
                fourtyHQJpySubTotal(page, 'SEA-015')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right">&nbsp;</td>
          </tr>

          <tr>
            <td></td>
            <td>Origin THC</td>
            <td>20F</td>
            <td style="text-align: right">
              {{
                (twentyFCurrency(page, 'SEA-016') +
                  twentyFPrice(page, 'SEA-016'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">{{ twentyFQty(page, 'SEA-016') }}</td>
            <td
              style="text-align: right"
              v-if="twentyFCurrency(page, 'SEA-016').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (twentyFCurrency(page, 'SEA-016') + twentyF(page, 'SEA-016'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="twentyFCurrency(page, 'SEA-016').indexOf('JPY') != -1"
            >
              {{
                twentyFJpySubTotal(page, 'SEA-016')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>40F</td>
            <td style="text-align: right">
              {{
                (fourtyFCurrency(page, 'SEA-016') +
                  fourtyFPrice(page, 'SEA-016'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">{{ fourtyFQty(page, 'SEA-016') }}</td>
            <td
              style="text-align: right"
              v-if="fourtyFCurrency(page, 'SEA-016').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (fourtyFCurrency(page, 'SEA-016') + fourtyF(page, 'SEA-016'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="fourtyFCurrency(page, 'SEA-016').indexOf('JPY') != -1"
            >
              {{
                fourtyFJpySubTotal(page, 'SEA-016')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>40H</td>
            <td style="text-align: right">
              {{
                (fourtyHQCurrency(page, 'SEA-016') +
                  fourtyHQPrice(page, 'SEA-016'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">
              {{ fourtyHQQty(page, 'SEA-016') }}
            </td>
            <td
              style="text-align: right"
              v-if="fourtyHQCurrency(page, 'SEA-016').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (fourtyHQCurrency(page, 'SEA-016') + fourtyHQ(page, 'SEA-016'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="fourtyHQCurrency(page, 'SEA-016').indexOf('JPY') != -1"
            >
              {{
                fourtyHQJpySubTotal(page, 'SEA-016')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right">&nbsp;</td>
          </tr>

          <tr>
            <td></td>
            <td colspan="2">Origin docfee</td>
            <td style="text-align: right"></td>
            <td style="text-align: right">
              {{ perBlSubTotal(page, 'SEA-017') ? 1 : null }}
            </td>
            <td
              style="text-align: right"
              v-if="perBlIsForeign(page, 'SEA-017')"
            >
              {{
                (perBlCurrency(page, 'SEA-017') +
                  perBlSubTotal(page, 'SEA-017'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right" v-else></td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="!perBlIsForeign(page, 'SEA-017')"
            >
              {{
                perBlJpySubTotal(page, 'SEA-017')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>

          <tr>
            <td></td>
            <td colspan="2">dofee</td>
            <td style="text-align: right"></td>
            <td style="text-align: right">
              {{ perBlSubTotal(page, 'SEA-018') ? 1 : null }}
            </td>
            <td
              style="text-align: right"
              v-if="perBlIsForeign(page, 'SEA-018')"
            >
              {{
                (perBlCurrency(page, 'SEA-018') +
                  perBlSubTotal(page, 'SEA-018'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right" v-else></td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="!perBlIsForeign(page, 'SEA-018')"
            >
              {{
                perBlJpySubTotal(page, 'SEA-018')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>

          <tr>
            <td></td>
            <td colspan="2">
              ( FREIGHT,s LSS, EXPORT CHARGE, <br />Origin THC, Origin DOCFEE,
              DO FEE ) TTL
            </td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right">
              {{
                (currency(page, 'SEA-001') +
                  (getTotal(page, 'SEA-001') +
                    getTotal(page, 'SEA-014') +
                    getTotal(page, 'SEA-015') +
                    getTotal(page, 'SEA-016') +
                    perBlSubTotal(page, 'SEA-017') +
                    perBlSubTotal(page, 'SEA-018')))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">USD->JPY RATE</td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right">
              {{ currencyRate(page, 'SEA-001') }}
            </td>
            <td style="text-align: right"></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">取次手数料</td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right">
              {{ (agencyFeeCurrency(page) + agencyFee(page)) | MCurrency }}
            </td>
            <td style="text-align: right">
              {{
                agencyFeeJpySubTotal(page)
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">
              消費税 {{ Math.round(jpyTaxRate(page, 'SEA-004') * 100) }}％
            </td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right">
              {{
                agencyTaxFeeJpySubTotal(page)
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
          </tr>
          <tr>
            <td></td>
            <td colspan="7" style="text-align: right">
              {{
                (agencyFeeJpySubTotal(page) + agencyTaxFeeJpySubTotal(page))
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
          </tr>

          <tr>
            <td style="width: 5%"></td>
            <td style="width: 15%">CIC</td>
            <td style="width: 10%">20F</td>
            <td style="text-align: right; width: 15%">
              {{
                (twentyFCurrency(page, 'SEA-003') +
                  twentyFPrice(page, 'SEA-003'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right; width: 10%">
              {{ twentyFQty(page, 'SEA-003') }}
            </td>
            <td
              style="text-align: right; width: 15%"
              v-if="twentyFCurrency(page, 'SEA-003').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right; width: 15%" v-else>
              {{
                (twentyFCurrency(page, 'SEA-003') + twentyF(page, 'SEA-003'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right; width: 15%"></td>
            <td
              style="text-align: right; width: 20%"
              v-if="twentyFCurrency(page, 'SEA-003').indexOf('JPY') != -1"
            >
              {{
                twentyFJpySubTotal(page, 'SEA-003')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right; width: 20%" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>40F</td>
            <td style="text-align: right">
              {{
                (fourtyFCurrency(page, 'SEA-003') +
                  fourtyFPrice(page, 'SEA-003'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">{{ fourtyFQty(page, 'SEA-003') }}</td>
            <td
              style="text-align: right"
              v-if="fourtyFCurrency(page, 'SEA-003').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (fourtyFCurrency(page, 'SEA-003') + fourtyF(page, 'SEA-003'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="fourtyFCurrency(page, 'SEA-003').indexOf('JPY') != -1"
            >
              {{
                fourtyFJpySubTotal(page, 'SEA-003')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>40H</td>
            <td style="text-align: right">
              {{
                (fourtyHQCurrency(page, 'SEA-003') +
                  fourtyHQPrice(page, 'SEA-003'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">
              {{ fourtyHQQty(page, 'SEA-003') }}
            </td>
            <td
              style="text-align: right"
              v-if="fourtyHQCurrency(page, 'SEA-003').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (fourtyHQCurrency(page, 'SEA-003') + fourtyHQ(page, 'SEA-003'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="fourtyHQCurrency(page, 'SEA-003').indexOf('JPY') != -1"
            >
              {{
                fourtyHQJpySubTotal(page, 'SEA-003')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="onlyForeignTotal(page, 'SEA-003') != 0"
            >
              {{
                (currency(page, 'SEA-003') + onlyForeignTotal(page, 'SEA-003'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right" v-else></td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="onlyJpyTotal(page, 'SEA-003') != 0"
            >
              {{
                onlyJpyTotal(page, 'SEA-003')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>

          <tr>
            <td></td>
            <td>THC</td>
            <td>20F</td>
            <td style="text-align: right">
              {{
                (twentyFCurrency(page, 'SEA-002') +
                  twentyFPrice(page, 'SEA-002'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">{{ twentyFQty(page, 'SEA-002') }}</td>
            <td
              style="text-align: right"
              v-if="twentyFCurrency(page, 'SEA-002').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (twentyFCurrency(page, 'SEA-002') + twentyF(page, 'SEA-002'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="twentyFCurrency(page, 'SEA-002').indexOf('JPY') != -1"
            >
              {{
                twentyFJpySubTotal(page, 'SEA-002')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>40F</td>
            <td style="text-align: right">
              {{
                (fourtyFCurrency(page, 'SEA-002') +
                  fourtyFPrice(page, 'SEA-002'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">{{ fourtyFQty(page, 'SEA-002') }}</td>
            <td
              style="text-align: right"
              v-if="fourtyFCurrency(page, 'SEA-002').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (fourtyFCurrency(page, 'SEA-002') + fourtyF(page, 'SEA-002'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="fourtyFCurrency(page, 'SEA-002').indexOf('JPY') != -1"
            >
              {{
                fourtyFJpySubTotal(page, 'SEA-002')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>40H</td>
            <td style="text-align: right">
              {{
                (fourtyHQCurrency(page, 'SEA-002') +
                  fourtyHQPrice(page, 'SEA-002'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right">
              {{ fourtyHQQty(page, 'SEA-002') }}
            </td>
            <td
              style="text-align: right"
              v-if="fourtyHQCurrency(page, 'SEA-002').indexOf('JPY') != -1"
            ></td>
            <td style="text-align: right" v-else>
              {{
                (fourtyHQCurrency(page, 'SEA-002') + fourtyHQ(page, 'SEA-002'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="fourtyHQCurrency(page, 'SEA-002').indexOf('JPY') != -1"
            >
              {{
                fourtyHQJpySubTotal(page, 'SEA-002')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="onlyForeignTotal(page, 'SEA-002') != 0"
            >
              {{
                (currency(page, 'SEA-002') + onlyForeignTotal(page, 'SEA-002'))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right" v-else></td>
            <td style="text-align: right"></td>
            <td
              style="text-align: right"
              v-if="onlyJpyTotal(page, 'SEA-002') != 0"
            >
              {{
                onlyJpyTotal(page, 'SEA-002')
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
        </table>
      </div>
      <div v-if="page.index === 1" class="page">
        <table>
          <tr class="header">
            <td style="width: 5%"></td>
            <td colspan="2" style="width: 25%">Description</td>
            <td colspan="3" style="width: 40%">Amount</td>
            <td style="width: 15%"></td>
            <td style="width: 15%">JPY Amount</td>
          </tr>
          <tr>
            <td style="width: 5%"></td>
            <td style="width: 15%">DOC</td>
            <td style="width: 10%">(/BL)</td>
            <td style="text-align: right; width: 15%"></td>
            <td style="text-align: right; width: 10%">
              {{ docFeeSubTotal(page) ? 1 : null }}
            </td>
            <td
              style="text-align: right; width: 15%"
              v-if="docFeeIsForeign(page)"
            >
              {{ (docFeeCurrency(page) + docFeeSubTotal(page)) | MCurrency }}
            </td>
            <td style="text-align: right; width: 15%" v-else></td>
            <td style="text-align: right; width: 15%"></td>
            <td
              style="text-align: right; width: 20%"
              v-if="!docFeeIsForeign(page)"
            >
              {{
                docFeeJpySubTotal(page)
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right; width: 20%" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>ADDITIONAL CHARGE</td>
            <td style="text-align: right"></td>
            <td style="text-align: right">
              {{ docTaxFeeSubTotal(page) ? 1 : null }}
            </td>
            <td style="text-align: right" v-if="docTaxFeeIsForeign(page)">
              {{
                (docTaxFeeCurrency(page) + docTaxFeeSubTotal(page)) | MCurrency
              }}
            </td>
            <td style="text-align: right" v-else></td>
            <td style="text-align: right"></td>
            <td style="text-align: right" v-if="!docTaxFeeIsForeign(page)">
              {{
                docTaxFeeJpySubTotal(page)
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right" v-if="docOnlyForeignTotal(page) != 0">
              {{
                (docForeignCurrency(page) + docOnlyForeignTotal(page))
                  | MCurrency
              }}
            </td>
            <td style="text-align: right" v-else></td>
            <td style="text-align: right"></td>
            <td style="text-align: right" v-if="docOnlyJpyTotal(page)">
              {{
                docOnlyJpyTotal(page)
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">Other Charge</td>
            <td style="text-align: right"></td>
            <td style="text-align: right">
              {{ otherFeeSubTotal(page) ? 1 : null }}
            </td>
            <td style="text-align: right" v-if="otherFeeIsForeign(page)">
              {{
                (otherFeeCurrency(page) + otherFeeSubTotal(page)) | MCurrency
              }}
            </td>
            <td style="text-align: right" v-else></td>
            <td style="text-align: right"></td>
            <td style="text-align: right" v-if="!otherFeeIsForeign(page)">
              {{
                otherFeeJpySubTotal(page)
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">SJL DIRECT 1</td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right" v-if="hot20FeeIsForeign(page)">
              {{
                (hot20FeeCurrency(page) + hot20FeeSubTotal(page)) | MCurrency
              }}
            </td>
            <td style="text-align: right" v-else></td>
            <td style="text-align: right"></td>
            <td style="text-align: right" v-if="!hot20FeeIsForeign(page)">
              {{
                hot20FeeJpySubTotal(page)
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">SJL DIRECT 2</td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right" v-if="hot40FeeIsForeign(page)">
              {{
                (hot40FeeCurrency(page) + hot40FeeSubTotal(page)) | MCurrency
              }}
            </td>
            <td style="text-align: right" v-else></td>
            <td style="text-align: right"></td>
            <td style="text-align: right" v-if="!hot40FeeIsForeign(page)">
              {{
                hot40FeeJpySubTotal(page)
                  | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
            <td style="text-align: right" v-else></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">CHARGE 合計</td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right"></td>
            <td style="text-align: right">
              {{
                chargeTotal(page) | currency({ symbol: '￥', fractionCount: 0 })
              }}
            </td>
          </tr>
          <tr class="header">
            <td colspan="5" style="text-align: center">Total</td>
            <td style="text-align: right">
              {{
                (currency(page, 'SEA-001') + chargeForeignTotal(page))
                  | MCurrency
              }}
              <br />
              {{ '￥' + foreignTotalToJpy(page) }}
            </td>
            <td></td>
            <td style="text-align: right">
              {{ total(page) | currency({ symbol: '￥', fractionCount: 0 }) }}
            </td>
          </tr>
        </table>

        <div class="C">
          PAYMENT TERMS：AIR：月末締め、翌月末支払い/
          SEA:月末締め、翌月10日支払い
        </div>
        <div class="D">
          <div style="padding-right: 30px">
            <div style="border-bottom: 1px solid #333; font-weight: bold">
              ドルのFREIGHTを下記の口座に入金してください
            </div>
            <ol class="d1">
              <li>銀行名 ： Mizuho Bank, Ltd.</li>
              <li>銀行名 ： Mizuho Bank, Ltd.</li>
              <li>SWIFT CODE/BIC CODE ： MHCBJPJT</li>
              <li>支店名：OSAKA CORPORATE BANKING BRANCH</li>
              <li>口座名義：SHARP JUSDA LOGISTICS CORPORATION</li>
              <li>口座番号：5444071</li>
              <li>
                銀行住所 4-2-1 Imabashi, Chuo-ku, Osaka-shi, Osaka 541-0042,
                Japan
              </li>
            </ol>
          </div>
          <div>
            <div style="border-bottom: 1px solid #333; font-weight: bold">
              円建ての料金を下記の口座に入金してください
            </div>
            <ul class="d2">
              <li>みずほ銀行</li>
              <li>大阪法人支店【０００１－０８０】</li>
              <li>当座・口座NO.5444071</li>
              <li>口座名義</li>
              <li>シャープジャスダロジスティクス株式会社</li>
            </ul>
          </div>
        </div>
        <div class="footer">SHARP JUSDA LOGISTICS CORPORATION</div>
      </div>
    </template>
  </output-dialog>
</template>
<script>
export default {
  data() {
    return {
      invoiceNos: '',
      pages: [{}],
    }
  },
  computed: {},
  methods: {
    max(a, b) {
      a = a || 0
      b = b || 0
      return Math.max(a, b)
    },
    popup(pages) {
      Promise.all(
        pages.map((p) =>
          this.$http.get(`/shipping-advices/${p.id}`).then((res) => {
            let data = res.data
            data.charges = data.charges.filter(
              (i) => i.chargeItemCode.indexOf('LOCAL') === -1
            )
            return data
          })
        )
      ).then((pages) => {
        const page0 = { ...pages[0], index: 0 }
        const page1 = { ...pages[0], index: 1 }
        this.pages = [page0, page1]
        this.$refs.printDlg.show = true
      })
    },
    invoiceNo(page) {
      return (
        page && page.packages && page.packages.map((p) => p.invoiceNo).join(',')
      )
    },
    charge(page, code, containerTypeCode) {
      return (
        (page.charges &&
          page.charges.find(
            (c) =>
              c.chargeItemCode === code &&
              (!containerTypeCode || containerTypeCode === c.containerTypeCode)
          )) ||
        {}
      )
    },
    charges(page, code, containerTypeCode) {
      let charges = page.charges || []
      return charges.filter(
        (c) =>
          code.indexOf(c.chargeItemCode) !== -1 &&
          (!containerTypeCode ||
            containerTypeCode.indexOf(c.containerTypeCode) !== -1)
      )
    },
    sum(page, code, containerTypeCode, field) {
      let charges = this.charges(page, code, containerTypeCode)
      return charges.reduce((t, c) => t + (c[field] || 0), 0)
    },
    fee(page, code, containerTypeCode) {
      return this.sum(page, code, containerTypeCode, 'subTotal')
    },
    jpyFee(page, code, containerTypeCode) {
      return this.sum(page, code, containerTypeCode, 'jpySubTotal')
    },
    jpyTaxFee(page, code, containerTypeCode) {
      return this.sum(page, code, containerTypeCode, 'jpyTaxTotal')
    },
    jpyTaxRate(page, code, containerTypeCode) {
      return this.sum(page, code, containerTypeCode, 'consumptionTaxRate')
    },

    shipmentCurrency(page, code, containerTypeCode) {
      return this.charge(page, code, containerTypeCode).currencyName
    },

    rate(page) {
      return (
        page.charges.find((c) => c.currencyRate && c.currencyCode === 'USD') ||
        {}
      ).currencyRate
    },

    getChargeValue(page, containerCode, chargeItemCode, find) {
      let arr = page.charges
        .filter(
          (c) =>
            (c.containerTypeCode != null &&
              c.containerTypeCode == containerCode) ||
            containerCode == null
        )
        .filter((c) => c.chargeItemCode == chargeItemCode)
        .map(find)
      return arr != null && arr.length > 0 ? arr[0] : null
    },
    getSubTotal(page, containerCode, chargeItemCode) {
      return this.getChargeValue(
        page,
        containerCode,
        chargeItemCode,
        (c) => c.subTotal
      )
    },
    twentyF(page, code) {
      return this.getSubTotal(page, '20F', code)
    },
    fourtyF(page, code) {
      return this.getSubTotal(page, '40F', code)
    },
    fourtyHQ(page, code) {
      return this.getSubTotal(page, '40FHQ', code)
    },
    getTotal(page, code) {
      return (
        (this.twentyF(page, code) || 0) +
        (this.fourtyF(page, code) || 0) +
        (this.fourtyHQ(page, code) || 0)
      )
    },
    onlyForeignTotal(page, code) {
      return [
        this.twentyFCurrency(page, code).indexOf('JPY') == -1
          ? this.twentyF(page, code)
          : 0,
        this.fourtyFCurrency(page, code).indexOf('JPY') == -1
          ? this.fourtyF(page, code)
          : 0,
        this.fourtyHQCurrency(page, code).indexOf('JPY') == -1
          ? this.fourtyHQ(page, code)
          : 0,
      ].reduce((x, y) => x + y)
    },
    getJpySubTotal(page, containerCode, chargeItemCode) {
      return this.getChargeValue(
        page,
        containerCode,
        chargeItemCode,
        (c) => c.jpySubTotal
      )
    },
    getJpyTaxTotal(page, containerCode, chargeItemCode) {
      return this.getChargeValue(
        page,
        containerCode,
        chargeItemCode,
        (c) => c.jpyTaxTotal
      )
    },
    twentyFJpySubTotal(page, code) {
      return this.getJpySubTotal(page, '20F', code)
    },
    fourtyFJpySubTotal(page, code) {
      return this.getJpySubTotal(page, '40F', code)
    },
    fourtyHQJpySubTotal(page, code) {
      return this.getJpySubTotal(page, '40FHQ', code)
    },
    getJpyTotal(page, code) {
      return (
        (this.twentyFJpySubTotal(page, code) || 0) +
        (this.fourtyFJpySubTotal(page, code) || 0) +
        (this.fourtyHQJpySubTotal(page, code) || 0)
      )
    },
    onlyJpyTotal(page, code) {
      return [
        this.twentyFCurrency(page, code).indexOf('JPY') != -1
          ? this.twentyFJpySubTotal(page, code)
          : 0,
        this.fourtyFCurrency(page, code).indexOf('JPY') != -1
          ? this.fourtyFJpySubTotal(page, code)
          : 0,
        this.fourtyHQCurrency(page, code).indexOf('JPY') != -1
          ? this.fourtyHQJpySubTotal(page, code)
          : 0,
      ].reduce((x, y) => x + y)
    },
    getQty(page, containerCode, chargeItemCode) {
      return this.getChargeValue(
        page,
        containerCode,
        chargeItemCode,
        (c) => c.qty
      )
    },
    twentyFQty(page, code) {
      return this.getQty(page, '20F', code)
    },
    fourtyFQty(page, code) {
      return this.getQty(page, '40F', code)
    },
    fourtyHQQty(page, code) {
      return this.getQty(page, '40FHQ', code)
    },

    getPrice(page, containerCode, chargeItemCode) {
      return (
        this.getChargeValue(
          page,
          containerCode,
          chargeItemCode,
          (c) => c.price
        ) || 0
      )
    },
    twentyFPrice(page, code) {
      return this.getPrice(page, '20F', code)
    },
    fourtyFPrice(page, code) {
      return this.getPrice(page, '40F', code)
    },
    fourtyHQPrice(page, code) {
      return this.getPrice(page, '40FHQ', code)
    },
    getCurrencyName(page, containerCode, chargeItemCode) {
      let currencyCode = this.getChargeValue(
        page,
        containerCode,
        chargeItemCode,
        (c) => c.currencyCode
      )
      let currencyName = this.getChargeValue(
        page,
        containerCode,
        chargeItemCode,
        (c) => c.currencyName
      )
      if (currencyCode == null || currencyName == null) return ''

      if (currencyCode === 'JPY') return currencyCode + ':'
      return currencyCode + ':' + currencyName + ':'
    },
    twentyFCurrency(page, code) {
      return this.getCurrencyName(page, '20F', code)
    },
    fourtyFCurrency(page, code) {
      return this.getCurrencyName(page, '40F', code)
    },
    fourtyHQCurrency(page, code) {
      return this.getCurrencyName(page, '40FHQ', code)
    },
    currency(page, code) {
      let arr = [
        this.twentyFCurrency(page, code),
        this.fourtyFCurrency(page, code),
        this.fourtyHQCurrency(page, code),
      ].filter((i) => i != '')
      return arr != null && arr.length > 0 ? arr[0] : ''
    },
    getCurrencyRate(page, containerCode, chargeItemCode) {
      return this.getChargeValue(
        page,
        containerCode,
        chargeItemCode,
        (c) => c.currencyRate
      )
    },
    twentyFRate(page, code) {
      return this.getCurrencyRate(page, '20F', code)
    },
    fourtyFRate(page, code) {
      return this.getCurrencyRate(page, '40F', code)
    },
    fourtyHQRate(page, code) {
      return this.getCurrencyRate(page, '40FHQ', code)
    },
    currencyRate(page, code) {
      let arr = [
        this.twentyFRate(page, code),
        this.fourtyFRate(page, code),
        this.fourtyHQRate(page, code),
      ].filter((i) => i != null)
      return arr != null && arr.length > 0 ? arr[0] : null
    },
    agencyFee(page) {
      return this.getSubTotal(page, null, 'SEA-004')
    },
    agencyFeeCurrency(page) {
      return this.getCurrencyName(page, null, 'SEA-004')
    },

    agencyFeeJpySubTotal(page) {
      return this.getJpySubTotal(page, null, 'SEA-004')
    },
    agencyTaxFeeJpySubTotal(page) {
      return this.max(
        this.getJpyTaxTotal(page, null, 'SEA-004'),
        this.getJpySubTotal(page, null, 'SEA-005')
      )
    },
    docFeeCurrency(page) {
      return this.getCurrencyName(page, null, 'SEA-006')
    },
    docFeeIsForeign(page) {
      return this.docFeeCurrency(page).indexOf('JPY') == -1
    },
    docFeeSubTotal(page) {
      return this.getSubTotal(page, null, 'SEA-006')
    },
    docFeeJpySubTotal(page) {
      return this.getJpySubTotal(page, null, 'SEA-006')
    },
    docTaxFeeCurrency(page) {
      return this.getCurrencyName(page, null, 'SEA-007')
    },
    docTaxFeeIsForeign(page) {
      return this.docTaxFeeCurrency(page).indexOf('JPY') == -1
    },
    docTaxFeeSubTotal(page) {
      return this.getSubTotal(page, null, 'SEA-007')
    },
    docTaxFeeJpySubTotal(page) {
      return this.getJpySubTotal(page, null, 'SEA-007')
    },
    docForeignCurrency(page) {
      if (this.docFeeIsForeign(page)) return this.docFeeCurrency(page)
      if (this.docTaxFeeIsForeign(page)) {
        return this.docTaxFeeCurrency()
      }
      return ''
    },
    docOnlyForeignTotal(page) {
      return [
        this.docFeeIsForeign(page) ? this.docFeeSubTotal(page) : 0,
        this.docTaxFeeIsForeign(page) ? this.docTaxFeeSubTotal(page) : 0,
      ].reduce((x, y) => x + y)
    },
    docOnlyJpyTotal(page) {
      return [
        this.docFeeIsForeign(page) ? 0 : this.docFeeJpySubTotal(page),
        this.docTaxFeeIsForeign(page) ? 0 : this.docTaxFeeJpySubTotal(page),
      ].reduce((x, y) => x + y)
    },
    otherFeeCurrency(page) {
      return this.getCurrencyName(page, null, 'SEA-008')
    },
    otherFeeIsForeign(page) {
      return this.otherFeeCurrency(page).indexOf('JPY') == -1
    },

    perBlCurrency(page, code) {
      return this.getCurrencyName(page, null, code)
    },
    perBlIsForeign(page, code) {
      return this.perBlCurrency(page, code).indexOf('JPY') == -1
    },
    perBlSubTotal(page, code) {
      return this.getSubTotal(page, null, code)
    },
    perBlJpySubTotal(page, code) {
      return this.getJpySubTotal(page, null, code)
    },

    otherFeeSubTotal(page) {
      return this.getSubTotal(page, null, 'SEA-008')
    },

    otherFeeJpySubTotal(page) {
      return this.getJpySubTotal(page, null, 'SEA-008')
    },
    hot20FeeSubTotal(page) {
      return this.getSubTotal(page, null, 'SEA-009')
    },
    hot20FeeCurrency(page) {
      return this.getCurrencyName(page, null, 'SEA-009')
    },
    hot20FeeIsForeign(page) {
      return this.hot20FeeCurrency(page).indexOf('JPY') == -1
    },
    hot20FeeJpySubTotal(page) {
      return this.getJpySubTotal(page, null, 'SEA-009')
    },
    hot40FeeCurrency(page) {
      return this.getCurrencyName(page, null, 'SEA-010')
    },
    hot40FeeIsForeign(page) {
      return this.hot40FeeCurrency(page).indexOf('JPY') == -1
    },
    hot40FeeSubTotal(page) {
      return this.getSubTotal(page, null, 'SEA-010')
    },
    hot40FeeJpySubTotal(page) {
      return this.getJpySubTotal(page, null, 'SEA-010')
    },
    foreign(page) {
      return this.getTotal(page, 'SEA-001')
    },
    foreignCurrency(page) {
      return (
        this.twentyFCurrency(page, 'SEA-001') ||
        this.fourtyFCurrency(page, 'SEA-001') ||
        this.fourtyHQCurrency(page, 'SEA-001')
      )
    },
    foreignRate(page) {
      return (
        this.twentyFRate(page, 'SEA-001') ||
        this.fourtyFRate(page, 'SEA-001') ||
        this.fourtyHQRate(page, 'SEA-001')
      )
    },

    excludeItemCodes() {
      return ['SEA-004', 'SEA-005', 'SEA-011', 'SEA-012', 'SEA-013']
    },
    chargeTotal(page) {
      return page.charges
        .filter((i) => i.currencyCode === 'JPY')
        .filter((i) => this.excludeItemCodes().indexOf(i.chargeItemCode) == -1)
        .map((i) => i.jpySubTotal)
        .reduce((x, y) => x + y, 0)
    },
    chargeForeignTotal(page) {
      return page.charges
        .filter((i) => i.currencyCode != 'JPY')
        .filter((i) => this.excludeItemCodes().indexOf(i.chargeItemCode) == -1)
        .map((i) => i.subTotal)
        .reduce((x, y) => x + y, 0)
    },
    foreignTotalToJpy(page) {
      return page.charges
        .filter((i) => i.currencyCode != 'JPY')
        .filter((i) => this.excludeItemCodes().indexOf(i.chargeItemCode) == -1)
        .map((i) => i.jpySubTotal)
        .reduce((x, y) => x + y, 0)
    },
    total(page) {
      return (
        this.chargeTotal(page) +
        this.agencyFeeJpySubTotal(page) +
        this.agencyTaxFeeJpySubTotal(page)
      )
    },
  },
  watch: {
    //006007
  },
}
</script>
<style scoped>
.page {
  padding: 20px;
  font-size: 14px;
}
h1 {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  background: #333;
  color: #fff;
  padding: 5px;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}
table .header {
  background: #333;
  color: #fff;
  font-weight: bold;
}
table .header td {
  border-color: #999;
}
table td {
  border: 1px solid #333;
  padding: 3px;
}
.no {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 15px;
}
.no > div {
  display: flex;
  flex-direction: row;
  padding: 5px;
}

.no > div > div.value {
  text-align: right;
  width: 120px;
}
.A {
  display: flex;
  flex-direction: row;
  padding: 15px;
}
.A .a {
  width: 50%;
  padding: 0px 3px;
}
.A .b {
  font-weight: bold;
}
.B {
  display: flex;
  flex-direction: row;
}
.B > div {
  width: 50%;
}
.B .a {
  padding-right: 15px;
}
.C {
  padding: 3px;
  background: #d2d2d2;
  margin-top: 20px;
}
.D {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}
.D > div {
  width: 50%;
}
.d1 {
  border-left: 3px solid red;
  margin-top: 15px;
}
.d2 {
  list-style: none;
  padding-left: 0px;
  margin-top: 15px;
}
.footer {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  bottom: 15px;
  left: 0px;
  width: 100%;
}
</style>
